import HELPER from '@/app/utils/HELPER';

(function (jQuery) {
  jQuery.gfMarginPadding = function (element, options) {
    const defaults = {
      onSelected: function (value) {},
    };
    this.settings = {};

    const $element = jQuery(element);
    const _this = this;

    let $targetElement;

    /* Editor */
    const $gfLeftSideBar = jQuery('#gfLeftSideBar');

    /* Iframe */
    const $gfFrame = jQuery('#gfFrame');
    const $gryffEditor = $gfFrame.contents().find('.gryffeditor').first();
    const $gryffBody = $gfFrame.contents().find('body').first();

    this.init = function () {
      const _this = this;
      this.settings = jQuery.extend({}, defaults, options);

      const merId = $gfLeftSideBar.find('#md-settings').data('edittingID');
      $targetElement = $gryffBody.find('#' + merId);

      if (
        $targetElement.hasClass('gf_row') &&
        ($element.attr('name') == 'margin-left' || $element.attr('name') == 'margin-right')
      ) {
        $element.attr('data-auto', 'true');
        $element.attr('value', 'auto').val('auto');
      }

      $element.gfInputField({
        onValueChanged: function (value) {
          // detect direction
          let direction = '';
          if ($element.hasClass('gf_padding')) {
            if ($targetElement.data('gfoutline') != undefined) {
              var name = $element.attr('name');
              switch (name) {
                case 'padding-top':
                  direction = 'top';
                  break;

                case 'padding-bottom':
                  direction = 'bottom';
                  break;

                case 'padding-left':
                  direction = 'left';
                  break;

                case 'padding-right':
                  direction = 'right';
                  break;
              }
            }
          } else if ($element.hasClass('gf_margin')) {
            if ($targetElement.data('gfoutline') != undefined) {
              var name = $element.attr('name');
              switch (name) {
                case 'margin-top':
                  direction = 'top';
                  break;

                case 'margin-bottom':
                  direction = 'bottom';
                  break;

                case 'margin-left':
                  direction = 'left';
                  break;

                case 'margin-right':
                  direction = 'right';
                  break;
              }
            }
          }

          // padding
          if (value.indexOf('px') == -1) {
            if ($element.hasClass('gf_padding')) {
              $targetElement.data('gfoutline').updatePadding(direction, value + 'px', true);
            } else if ($element.hasClass('gf_margin')) {
              $targetElement.data('gfoutline').updateMargin(direction, value + 'px', true);
            }
          } else {
            if ($element.hasClass('gf_padding')) {
              $targetElement.data('gfoutline').updatePadding(direction, value, true);
            } else if ($element.hasClass('gf_margin')) {
              $targetElement.data('gfoutline').updateMargin(direction, value, true);
            }
          }

          // Update value
          if (value.indexOf('px') == -1) {
            $element.attr('value', value + 'px').trigger('input-change');
          } else {
            $element.attr('value', value).trigger('input-change');
          }
        },
      });

      const $gfInputField = $element.next('.gfInputField');
      $gfInputField
        .find('input')
        .off('mouseover.mp')
        .on('mouseover.mp', function (e) {
          //return if readonly
          if (jQuery(this).attr('readonly')) {
            return;
          }

          if (!$gryffEditor.data('gryffeditor').isDragging()) {
            window._gTimeOut = setTimeout(function () {
              if ($element.hasClass('gf_padding')) {
                if ($targetElement.data('gfoutline') != undefined) {
                  var direction = '';

                  var name = $element.attr('name');
                  switch (name) {
                    case 'padding-top':
                      direction = 'top';
                      break;

                    case 'padding-bottom':
                      direction = 'bottom';
                      break;

                    case 'padding-left':
                      direction = 'left';
                      break;

                    case 'padding-right':
                      direction = 'right';
                      break;
                  }
                  $targetElement.data('gfoutline').showPadding(direction, true);
                }
              } else if ($element.hasClass('gf_margin')) {
                if ($targetElement.data('gfoutline') != undefined) {
                  var direction = '';

                  var name = $element.attr('name');
                  switch (name) {
                    case 'margin-top':
                      direction = 'top';
                      break;

                    case 'margin-bottom':
                      direction = 'bottom';
                      break;

                    case 'margin-left':
                      direction = 'left';
                      break;

                    case 'margin-right':
                      direction = 'right';
                      break;
                  }

                  if ($targetElement.data('gfoutline')) {
                    $targetElement.data('gfoutline').updateMargin(direction);
                    $targetElement.data('gfoutline').showMargin(direction, true);
                  }
                }
              }
            }, 200);
          }
        });

      $gfInputField
        .find('input')
        .off('mouseleave.mp')
        .on('mouseleave.mp', function (e) {
          if (!$gryffEditor.data('gryffeditor').isDragging()) {
            clearTimeout(window._gTimeOut);

            if ($element.hasClass('gf_padding')) {
              if ($targetElement.data('gfoutline')) {
                $targetElement.data('gfoutline').hidePadding();
              }
            } else if ($element.hasClass('gf_margin')) {
              if ($targetElement.data('gfoutline')) {
                $targetElement.data('gfoutline').hideMargin();
              }
            }
          }
        });

      $gfInputField
        .find('input')
        .off('mousedown.mp')
        .on('mousedown.mp', function (e) {
          //return if readonly
          if (jQuery(this).attr('readonly')) {
            return;
          }

          jQuery(this).addClass('scrolling');

          $gryffEditor.data('gryffeditor').setDragging(true);

          let $that = jQuery(this),
            start = e.pageY,
            end,
            old = parseInt($that.val()) || 0;
          let direction = '';
          if ($element.hasClass('gf_padding')) {
            if ($targetElement.data('gfoutline') != undefined) {
              var name = $element.attr('name');
              switch (name) {
                case 'padding-top':
                  direction = 'top';
                  break;

                case 'padding-bottom':
                  direction = 'bottom';
                  break;

                case 'padding-left':
                  direction = 'left';
                  break;

                case 'padding-right':
                  direction = 'right';
                  break;
              }
            }
          } else if ($element.hasClass('gf_margin')) {
            if ($targetElement.data('gfoutline') != undefined) {
              var name = $element.attr('name');
              switch (name) {
                case 'margin-top':
                  direction = 'top';
                  break;

                case 'margin-bottom':
                  direction = 'bottom';
                  break;

                case 'margin-left':
                  direction = 'left';
                  break;

                case 'margin-right':
                  direction = 'right';
                  break;
              }
            }
          }

          $gfLeftSideBar.trigger('init.mousemove.mp', {
            locate: { direction, $that, start, old },
            $element,
            $targetElement,
          });
          $gfLeftSideBar.trigger('init.mouseup.mp', { $that, $element, $gfInputField, $targetElement });
        });

      // Cho phép phím lên xuống để tăng giảm input;
      $gfInputField
        .find('input')
        .off('keydown.upDown')
        .on('keydown.upDown', function (e) {
          const $that = $(this);
          const old = parseInt($that.val()) || 0;

          const keyUp = 38;
          const keyDown = 40;
          if (e.which == keyUp) {
            if (e.shiftKey) {
              var newVar = old + 10;
            } else {
              var newVar = old + 1;
            }
            if (
              $targetElement.hasClass('gf_row') &&
              ($element.attr('name') == 'margin-left' || $element.attr('name') == 'margin-right')
            ) {
              newVar = 'auto';
            }

            if ($element.hasClass('gf_padding') && newVar < 0) {
              newVar = '0';
            }

            $that.val(newVar);

            var value = newVar + 'px';
            $element.attr('value', value).trigger('input-change').trigger('value-change');
            $element
              .parent()
              .find('input.gf_remove-spin-button')
              .attr('value', _this.removePx(value))
              .val(_this.removePx(value));
          } else if (e.which == keyDown) {
            if (e.shiftKey) {
              var newVar = old - 10;
            } else {
              var newVar = old - 1;
            }

            if (
              $targetElement.hasClass('gf_row') &&
              ($element.attr('name') == 'margin-left' || $element.attr('name') == 'margin-right')
            ) {
              newVar = 'auto';
            }

            if ($element.hasClass('gf_padding') && newVar < 0) {
              newVar = '0';
            }

            $that.val(newVar);

            var value = newVar + 'px';
            $element.attr('value', value).trigger('input-change').trigger('value-change');
            $element
              .parent()
              .find('input.gf_remove-spin-button')
              .attr('value', _this.removePx(value))
              .val(_this.removePx(value));
          }

          // detect direction
          let direction = '';
          if ($element.hasClass('gf_padding')) {
            if ($targetElement.data('gfoutline') != undefined) {
              var name = $element.attr('name');
              switch (name) {
                case 'padding-top':
                  direction = 'top';
                  break;

                case 'padding-bottom':
                  direction = 'bottom';
                  break;

                case 'padding-left':
                  direction = 'left';
                  break;

                case 'padding-right':
                  direction = 'right';
                  break;
              }
            }
          } else if ($element.hasClass('gf_margin')) {
            if ($targetElement.data('gfoutline') != undefined) {
              var name = $element.attr('name');
              switch (name) {
                case 'margin-top':
                  direction = 'top';
                  break;

                case 'margin-bottom':
                  direction = 'bottom';
                  break;

                case 'margin-left':
                  direction = 'left';
                  break;

                case 'margin-right':
                  direction = 'right';
                  break;
              }
            }
          }
          // padding
          if ($element.hasClass('gf_padding')) {
            $targetElement.data('gfoutline').updatePadding(direction, value, true);
          } else if ($element.hasClass('gf_margin')) {
            $targetElement.data('gfoutline').updateMargin(direction, value, true);
          }
        });

      return false;
    };

    this.removePx = function (value) {
      let newValue = value;
      if (newValue && newValue.includes('px')) {
        newValue = newValue.replace('px', '');
      }
      return newValue;
    };

    this.applyEvents = function () {
      return false;
    };

    this.init();
  };
  jQuery.fn.gfMarginPadding = function (options) {
    return this.each(function () {
      if (undefined == jQuery(this).data('gfmarginpadding')) {
        const plugin = new jQuery.gfMarginPadding(this, options);
        jQuery(this).data('gfmarginpadding', plugin);
      }
    });
  };
})(jQuery);
